<template>
  <div class="mt-4 about-page">
    <div class="row">
      <div class="col-4 col-lg-3">
        <about-nav />
      </div>
      <div class="col-8 text-left">
        <h2>About</h2>
        <p>Gradient Magic is the largest gallery of CSS Gradients on the web, with new and exciting gradients added all the time.</p>

        <h4 class="mb-3 mt-4">What are CSS Gradients?</h4>
        <p>
            CSS Gradients are fancy patterns created via CSS, primarily used to add color or patterns to a website. 
            They have many <a href="https://www.gradientmagic.com/blog/2019/07/27/why-gradients/">benefits</a> over images, including being easier to work with and much smaller in size.  
        </p>

        <h4 class="mb-3 mt-4">License &amp; Usage</h4>
        <p>
          As long as you don't re-distribute or re-sell gradients or derived images from gradientmagic.com, 
          you may use them on personal or commercial projects <strong>with attribution</strong>.
        </p>
        <p>
          To use gradients without attribution you need to purchase either the
          <router-link to="/premium">standard license</router-link> or the <router-link to="/extended">extended license</router-link>.
        </p>

        
        <h4 class="mt-4 mb-3">Attribution</h4>
        <p>
          Please credit Gradient Magic when using gradients or derived images.  This can be in the form of a caption, short sentence, or CSS comment.
          Please also include a link back to the site.
        </p>
        <p>
          <span class="font-weight-bold">Example</span>
        </p>
        <div class="card rounded bg-light mb-5">
          <div class="card-body">
            Image courtesy of <a href="www.gradientmagic.com" class="">gradientmagic.com</a>
          </div>
        </div>

        <!-- <h4 class="mt-4 mb-4">Contact</h4>
        <div class="alert alert-primary">
          <p>
            <strong>Please give feedback!</strong> It only takes a few minutes, and helps me choose what kind of gradients and features to add next.
          </p>
          <p class="mb-0"><a href="https://docs.google.com/forms/d/e/1FAIpQLSeSDGnHL4n_kFXNO4JLrSqSBKHbMJo_yVn1TzmjFx4ZexMMhA/viewform?usp=sf_link">Short Contact Form</a></p>
        </div> -->

      </div>
    </div>
    <!-- <div class="row">
        <div class="col-12 col-lg-8 pl-4 pr-4 text-left bg-white">
            <h2 class="">About</h2>
            <p>Gradient Magic is the largest gallery of CSS Gradients on the web, with new and exciting gradients added every day.</p>

            <h4 class="mb-4 mt-4">What are CSS Gradients?</h4>
            <p>
               CSS Gradients are fancy patterns created via CSS, primarily used to add color or patterns to a website. 
               They have many <a href="https://www.gradientmagic.com/blog/2019/07/27/why-gradients/">benefits</a> over images, including being easier to work with and much smaller in size.  
            </p>

            <p>More questions? <a href="https://www.gradientmagic.com/blog/2019/08/18/faq/">Read the FAQ</a></p>

            <h4 class="mt-4 mb-4">Contact</h4>
            <div class="alert alert-primary">
              <p>
                <strong>Please give feedback!</strong> It only takes a few minutes, and helps me choose what kind of gradients and features to add next.
              </p>
              <p class="mb-0"><a href="https://docs.google.com/forms/d/e/1FAIpQLSeSDGnHL4n_kFXNO4JLrSqSBKHbMJo_yVn1TzmjFx4ZexMMhA/viewform?usp=sf_link">Short Contact Form</a></p>
              
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 text-left mt-4 d-flex">
          <div class="p-4 border border-light bg-light rounded w-100">
            <p><strong>Learn About CSS Gradients</strong></p>
            <p><a href="https://www.gradientmagic.com/blog/2019/08/08/how-to/">How to Use CSS Gradients</a></p>
            <p><a href="https://www.gradientmagic.com/blog/2019/07/27/why-gradients/">Why Use CSS Gradients?</a></p>
            <p><a href="https://www.gradientmagic.com/blog/">The Blog</a></p>
            <p class="mt-4"><strong>More Resources</strong></p>
            <p><a href="https://cssgradient.io/" target="_blank">Gradient Editor</a></p>
            <p><a href="https://gradientgenerator.com/" target="_blank">Simple Gradient Editor</a></p>
            <p><a href="https://leaverou.github.io/css3patterns/" target="_blank">Cool Gradient Patterns</a></p>

          </div>
        </div>
    </div> -->
    <!-- <p><a href="https://docs.google.com/forms/d/e/1FAIpQLSeSDGnHL4n_kFXNO4JLrSqSBKHbMJo_yVn1TzmjFx4ZexMMhA/viewform?usp=sf_link">Contact Form</a></p>
        <p><a href="https://twitter.com/GradientMagic">Twitter</a></p>
        <p><a href="https://www.instagram.com/GradientMagic/">Instagram</a></p> -->
  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  },
  metaInfo: {
    title: "About Gradient Magic"
  } 
}
</script>

<style lang="scss">
.about-page {
  .decoration {
    // background: linear-gradient(90deg, white 0%, white 65%,rgb(127, 191, 229) 65%, rgb(127, 191, 229) 70%,rgb(86, 170, 237) 70%, rgb(86, 170, 237) 75%,rgb(44, 150, 245) 75%, rgb(44, 150, 245) 80%,rgb(3, 129, 253) 80%, rgb(3, 129, 253) 100%);
    background: linear-gradient(225deg, rgb(64, 140, 190) 0%, rgb(64, 140, 190) 7%,rgb(62, 107, 145) 7%, rgb(62, 107, 145) 9%,rgb(49, 99, 131) 9%, rgb(49, 99, 131) 11%,rgb(116, 172, 211) 11%, rgb(116, 172, 211) 26%,rgb(125, 182, 214) 26%, rgb(125, 182, 214) 34%,rgb(40, 90, 136) 34%, rgb(40, 90, 136) 41%,rgb(39, 123, 190) 41%, rgb(39, 123, 190) 100%);
    // background: linear-gradient(315deg, rgb(164, 210, 185) 0%, rgb(164, 210, 185) 13%,rgb(140, 185, 176) 13%, rgb(140, 185, 176) 18%,rgb(116, 160, 167) 18%, rgb(116, 160, 167) 22%,rgb(92, 135, 158) 22%, rgb(92, 135, 158) 23%,rgb(67, 109, 148) 23%, rgb(67, 109, 148) 26%,rgb(43, 84, 139) 26%, rgb(43, 84, 139) 31%,rgb(19, 59, 130) 31%, rgb(19, 59, 130) 100%)
    // background: linear-gradient(225deg, rgb(16, 52, 222) 0%, rgb(16, 52, 222) 6%,rgb(41, 77, 223) 6%, rgb(41, 77, 223) 18%,rgb(67, 103, 224) 18%, rgb(67, 103, 224) 30%,rgb(92, 128, 225) 30%, rgb(92, 128, 225) 31%,rgb(117, 153, 227) 31%, rgb(117, 153, 227) 37%,rgb(142, 178, 228) 37%, rgb(142, 178, 228) 41%,rgb(168, 204, 229) 41%, rgb(168, 204, 229) 69%,rgb(193, 229, 230) 69%, rgb(193, 229, 230) 100%)
  }
}
</style>